import AXIOS from "@/axios";
import { APIResponse } from "@/types/user.model";

export interface EmailTemplateListItem {
  id: string;
  code: string;
  name: string;
  last_updated: string;
  is_active: boolean;
}

export interface EmailTemplateDetail {
  id: string;
  code: string;
  name: string;
  subject: string;
  body: string;
  is_active: boolean;
  created_on: string;
  updated_on: string;
}

export interface EmailTemplateUpdatePayload {
  code: string;
  name: string;
  subject: string;
  body: string;
}

export const getEmailTemplatesService = () => {
  return AXIOS.get<APIResponse<EmailTemplateListItem[]>>(
    "/base/v1/email-template"
  );
};

export const getEmailTemplateByIdService = (id: string) => {
  return AXIOS.get<APIResponse<EmailTemplateDetail>>(
    `/base/v1/email-template/${id}`
  );
};

export const updateEmailTemplateService = (
  id: string,
  payload: EmailTemplateUpdatePayload
) => {
  return AXIOS.put<APIResponse<EmailTemplateDetail>>(
    `/base/v1/email-template/${id}`,
    payload
  );
};
